<template>
  <div>
    <div class="breadcrumb">
      <axe-breadcrumb separator-class="el-icon-arrow-right">
        <axe-breadcrumb-item :to="{ path: '/measure/reportManagement' }">报告管理</axe-breadcrumb-item>
        <axe-breadcrumb-item>学生报告</axe-breadcrumb-item>
      </axe-breadcrumb>
    </div>
    <div class="content-box">
      <div>
        <axe-form
          inline
          size="small"
          class="queryForm"
          :model="queryForm"
        >
          <axe-form-item label="选择年级">
            <axe-select
              v-model="queryForm.gradeId"
              placeholder="请选择"
              @change="selectGrade"
            >
              <axe-option
                label="全部"
                value=""
              > </axe-option>
              <axe-option
                v-for="item in gradeOptions"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </axe-option>
            </axe-select>
          </axe-form-item>
          <axe-form-item label="选择班级">
            <axe-select
              v-model="queryForm.classId"
              placeholder="请选择"
              :disabled="!queryForm.gradeId"
              @change="getData(true)"
            >
              <axe-option
                label="全部"
                value=""
              ></axe-option>
              <axe-option
                v-for="item in classOptions"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </axe-option>
            </axe-select>
          </axe-form-item>
          <axe-form-item class="keyWord">
            <axe-input
              v-model="queryForm.userName"
              size="small"
              placeholder="请输入姓名"
              @keyup.enter.native="getData(true)"
            ><span
                slot="suffix"
                class="icon"
                @click="getData(true)"
              ><i class="el-input__icon el-icon-search"></i></span></axe-input>
          </axe-form-item>
        </axe-form>
      </div>
      <!-- 危险预警列表 -->
      <div class="tables">
        <axe-table
          :data="tableData"
          :loading="tableLoading"
          stripe
          style="width: 100%"
        >
          <axe-table-column
            prop="userName"
            label="姓名"
            show-overflow-tooltip
          >
          </axe-table-column>
          <axe-table-column
            prop="sex"
            label="性别"
            show-overflow-tooltip
          >
            <template slot-scope="scoped">{{
              scoped.row.sex === 0
                ? "女"
                : scoped.row.sex === 1
                ? "男"
                : "暂无"
            }}</template>
          </axe-table-column>
          <axe-table-column
            prop="className"
            label="班级"
            show-overflow-tooltip
          ></axe-table-column>
          <axe-table-column
            prop="headmasterName"
            label="班主任"
            show-overflow-tooltip
          ><template slot-scope="scoped">{{
              scoped.row.headmasterName || "暂无"
            }}</template></axe-table-column>
          <axe-table-column
            label="操作"
            width="160"
          >
            <template slot-scope="scope">
              <axe-button
                class="opeatBtn"
                @click="viewDetail(scope.row)"
                type="text"
              >查看</axe-button>
            </template>
          </axe-table-column>
        </axe-table>
      </div>
      <!-- 分页 -->
      <Pagination
        ref="pageNation"
        :pageSize="page.pageSize"
        :pageNum="page.pageNum"
        :total="total"
        @handleCurrent="handleCurrent"
      />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/pagination";
export default {
  props: {},
  components: {
    Pagination,
  },
  data () {
    return {
      queryForm: {
        gradeId: "", // 年级
        classId: "", // 班级
        userName: "", // 内容
      }, //查询列表
      tableData: [], // 学生报告列表
      tableLoading: false, // 列表加载状态
      page: {
        pageSize: 10,
        pageNum: 1,
      }, // 分页信息
      total: 1, // 数据总条数
      gradeOptions: [
        {
          "code": "12",
          "name": "高三",
          "children": [
            {
              "code": "1500000200060858251",
              "name": "2班",
              "children": null
            },
            {
              "code": "1500000200060858949",
              "name": "1班",
              "children": null
            }
          ]
        },
        {
          "code": "11",
          "name": "高二",
          "children": [
            {
              "code": "1500000200060858250",
              "name": "2班",
              "children": null
            },
            {
              "code": "1500000200060858948",
              "name": "1班改ER班",
              "children": null
            },
            {
              "code": "1500000200061003109",
              "name": "3班111",
              "children": null
            },
            {
              "code": "1500000200061003110",
              "name": "4班",
              "children": null
            },
            {
              "code": "1500000200061003111",
              "name": "5班",
              "children": null
            },
            {
              "code": "1500000200061003112",
              "name": "6班",
              "children": null
            },
            {
              "code": "1500000200061003113",
              "name": "7班",
              "children": null
            },
            {
              "code": "1500000200061003114",
              "name": "8班",
              "children": null
            },
            {
              "code": "1500000200061003115",
              "name": "9班",
              "children": null
            },
            {
              "code": "1500000200061003116",
              "name": "10班",
              "children": null
            },
            {
              "code": "1500000200061003117",
              "name": "11班",
              "children": null
            },
            {
              "code": "1500000200061003118",
              "name": "12班",
              "children": null
            },
            {
              "code": "1500000200061326437",
              "name": "二班",
              "children": null
            }
          ]
        },
        {
          "code": "10",
          "name": "高一",
          "children": [
            {
              "code": "1500000200060858946",
              "name": "1班改222",
              "children": null
            },
            {
              "code": "1500000200061325886",
              "name": "二班",
              "children": null
            },
            {
              "code": "1500000200061361373",
              "name": "2班改",
              "children": null
            }
          ]
        },
        {
          "code": "09",
          "name": "九年级",
          "children": [
            {
              "code": "1500000200060858248",
              "name": "1班",
              "children": null
            },
            {
              "code": "1500000200060858249",
              "name": "2班",
              "children": null
            }
          ]
        },
        {
          "code": "08",
          "name": "八年级",
          "children": [
            {
              "code": "1500000200060858944",
              "name": "1班",
              "children": null
            },
            {
              "code": "1500000200060858945",
              "name": "2班",
              "children": null
            }
          ]
        },
        {
          "code": "07",
          "name": "七年级",
          "children": [
            {
              "code": "1500000200060858246",
              "name": "1班",
              "children": null
            },
            {
              "code": "1500000200060858247",
              "name": "2班",
              "children": null
            }
          ]
        },
        {
          "code": "06",
          "name": "六年级",
          "children": [
            {
              "code": "1500000200060932480",
              "name": "1班",
              "children": null
            }
          ]
        },
        {
          "code": "05",
          "name": "五年级",
          "children": [
            {
              "code": "1500000200061488614",
              "name": "1班",
              "children": null
            },
            {
              "code": "1500000200061488615",
              "name": "2班",
              "children": null
            },
            {
              "code": "1500000200061488616",
              "name": "3班",
              "children": null
            }
          ]
        },
        {
          "code": "04",
          "name": "四年级",
          "children": [
            {
              "code": "1500000200060999374",
              "name": "1班",
              "children": null
            },
            {
              "code": "1500000200060999512",
              "name": "2班",
              "children": null
            }
          ]
        },
        {
          "code": "03",
          "name": "三年级",
          "children": [
            {
              "code": "1500000200060999372",
              "name": "1班改",
              "children": null
            }
          ]
        },
        {
          "code": "02",
          "name": "二年级",
          "children": null
        },
        {
          "code": "01",
          "name": "一年级",
          "children": [
            {
              "code": "1500000200061495361",
              "name": "一班改21",
              "children": null
            }
          ]
        }
      ], // 年级下拉框列表
      classOptions: [
        { name: '全部', code: 'all' },
      ], // 班级下拉框列表
      allData: [],
    };
  },
  computed: {
  },
  watch: {},
  created () {
    this.getData();
  },
  mounted () {
  },
  methods: {
    // 获取学生报告列表
    getData (value) {
      let res = {
        "pageNo": 1,
        "pageSize": 10,
        "totalCount": 20,
        "dataList": [
          {
            "id": "154102",
            "gaugeId": "e15388e7f0f8454cb74a544050277796",
            "taskId": "1616126432383616",
            "userId": "1500000200061498487",
            "uncompletedNo": null,
            "completedNo": null,
            "aliasNo": null,
            "completeFlag": 1,
            "gradeId": "01",
            "gradeName": "一年级",
            "classId": "1500000200061495361",
            "className": "一班改21",
            "headmasterId": "1500000200061356713",
            "score": 0,
            "startTime": "2022-05-20T10:19:04.000+00:00",
            "reportDuration": null,
            "userName": "1年级tu",
            "account": null,
            "duration": 7350,
            "warnFlag": 1,
            "cancelWarnUser": null,
            "cancelWarnTime": null,
            "sex": null,
            "headmasterName": "心育3管理员",
            "schoolId": "1500000200060858208",
            "schoolName": "智慧心育测试校3",
            "businessId": "1616160739103360",
            "userAge": 0,
            "guageName": null,
            "endTime": "2022-05-20 18:19:04",
            "evaluateType": 2,
            "deleteFlag": null,
            "effectiveFlag": 1,
            "createUser": null,
            "createTime": null,
            "modifyUser": null,
            "modifyTime": null,
            "doneRate": null,
            "code": null,
            "name": null,
            "totalNo": null
          },
          {
            "id": "154110",
            "gaugeId": "e15388e7f0f8454cb74a544050277796",
            "taskId": "1616648426951296",
            "userId": "1500000200061498495",
            "uncompletedNo": null,
            "completedNo": null,
            "aliasNo": null,
            "completeFlag": 1,
            "gradeId": "01",
            "gradeName": "一年级",
            "classId": "1500000200061495361",
            "className": "一班改21",
            "headmasterId": "1500000200061356713",
            "score": 0,
            "startTime": "2022-05-20T12:36:53.000+00:00",
            "reportDuration": null,
            "userName": "tu2改",
            "account": null,
            "duration": 4140,
            "warnFlag": 1,
            "cancelWarnUser": null,
            "cancelWarnTime": null,
            "sex": 0,
            "headmasterName": "心育3管理员",
            "schoolId": "1500000200060858208",
            "schoolName": "智慧心育测试校3",
            "businessId": "1616702635529920",
            "userAge": 13,
            "guageName": null,
            "endTime": "2022-05-20 20:36:53",
            "evaluateType": 2,
            "deleteFlag": null,
            "effectiveFlag": 1,
            "createUser": null,
            "createTime": null,
            "modifyUser": null,
            "modifyTime": null,
            "doneRate": null,
            "code": null,
            "name": null,
            "totalNo": null
          },
          {
            "id": "154108",
            "gaugeId": "e15388e7f0f8454cb74a544050277796",
            "taskId": "1616648426951296",
            "userId": "1500000200061498908",
            "uncompletedNo": null,
            "completedNo": null,
            "aliasNo": null,
            "completeFlag": 1,
            "gradeId": "01",
            "gradeName": "一年级",
            "classId": "1500000200061495361",
            "className": "一班改21",
            "headmasterId": "1500000200061356713",
            "score": 0,
            "startTime": "2022-05-20T12:23:59.000+00:00",
            "reportDuration": null,
            "userName": "tu5",
            "account": null,
            "duration": 3685,
            "warnFlag": 1,
            "cancelWarnUser": null,
            "cancelWarnTime": null,
            "sex": null,
            "headmasterName": "心育3管理员",
            "schoolId": "1500000200060858208",
            "schoolName": "智慧心育测试校3",
            "businessId": "1616651932930688",
            "userAge": 0,
            "guageName": null,
            "endTime": "2022-05-20 20:24:00",
            "evaluateType": 2,
            "deleteFlag": null,
            "effectiveFlag": 1,
            "createUser": null,
            "createTime": null,
            "modifyUser": null,
            "modifyTime": null,
            "doneRate": null,
            "code": null,
            "name": null,
            "totalNo": null
          },
          {
            "id": "154109",
            "gaugeId": "e15388e7f0f8454cb74a544050277796",
            "taskId": "1616648426951296",
            "userId": "1500000200061498909",
            "uncompletedNo": null,
            "completedNo": null,
            "aliasNo": null,
            "completeFlag": 1,
            "gradeId": "01",
            "gradeName": "一年级",
            "classId": "1500000200061495361",
            "className": "一班改21",
            "headmasterId": "1500000200061356713",
            "score": 0,
            "startTime": "2022-05-20T12:25:04.000+00:00",
            "reportDuration": null,
            "userName": "tu6",
            "account": null,
            "duration": 3813,
            "warnFlag": 1,
            "cancelWarnUser": null,
            "cancelWarnTime": null,
            "sex": null,
            "headmasterName": "心育3管理员",
            "schoolId": "1500000200060858208",
            "schoolName": "智慧心育测试校3",
            "businessId": "1616656208171648",
            "userAge": 0,
            "guageName": null,
            "endTime": "2022-05-20 20:25:04",
            "evaluateType": 2,
            "deleteFlag": null,
            "effectiveFlag": 1,
            "createUser": null,
            "createTime": null,
            "modifyUser": null,
            "modifyTime": null,
            "doneRate": null,
            "code": null,
            "name": null,
            "totalNo": null
          },
          {
            "id": "154085",
            "gaugeId": "1495688475775616",
            "taskId": "1614340125513408",
            "userId": "1500000200061495824",
            "uncompletedNo": null,
            "completedNo": null,
            "aliasNo": null,
            "completeFlag": 1,
            "gradeId": "07",
            "gradeName": "七年级",
            "classId": "1500000200060858247",
            "className": "七年级2班",
            "headmasterId": null,
            "score": 0,
            "startTime": "2022-05-20T03:43:10.000+00:00",
            "reportDuration": null,
            "userName": "七年级一号",
            "account": null,
            "duration": 5183,
            "warnFlag": 1,
            "cancelWarnUser": null,
            "cancelWarnTime": null,
            "sex": null,
            "headmasterName": null,
            "schoolId": "1500000200060858208",
            "schoolName": "智慧心育测试校3",
            "businessId": "1614603992961664",
            "userAge": 0,
            "guageName": null,
            "endTime": "2022-05-20 11:43:10",
            "evaluateType": 2,
            "deleteFlag": null,
            "effectiveFlag": 0,
            "createUser": null,
            "createTime": null,
            "modifyUser": null,
            "modifyTime": null,
            "doneRate": null,
            "code": null,
            "name": null,
            "totalNo": null
          },
          {
            "id": "154100",
            "gaugeId": "1495688475775616",
            "taskId": "1614340125513408",
            "userId": "1500000200061495823",
            "uncompletedNo": null,
            "completedNo": null,
            "aliasNo": null,
            "completeFlag": 1,
            "gradeId": "03",
            "gradeName": "三年级",
            "classId": "1500000200060999372",
            "className": "1班改",
            "headmasterId": "1500000200061495832",
            "score": 0,
            "startTime": "2022-05-20T09:52:58.000+00:00",
            "reportDuration": 5855,
            "userName": "三年级一号",
            "account": null,
            "duration": 4414,
            "warnFlag": 1,
            "cancelWarnUser": null,
            "cancelWarnTime": null,
            "sex": null,
            "headmasterName": "新增老师改",
            "schoolId": "1500000200060858208",
            "schoolName": "智慧心育测试校3",
            "businessId": "1616058096292480",
            "userAge": 0,
            "guageName": null,
            "endTime": "2022-05-20 17:52:58",
            "evaluateType": 2,
            "deleteFlag": null,
            "effectiveFlag": 0,
            "createUser": null,
            "createTime": null,
            "modifyUser": null,
            "modifyTime": null,
            "doneRate": null,
            "code": null,
            "name": null,
            "totalNo": null
          },
          {
            "id": "153459",
            "gaugeId": "5b04425ed049437ea38151cce531a7f5",
            "taskId": "1440998803903104",
            "userId": "1500000200060858252",
            "uncompletedNo": null,
            "completedNo": null,
            "aliasNo": null,
            "completeFlag": 1,
            "gradeId": "07",
            "gradeName": "七年级",
            "classId": "1500000200060858246",
            "className": "1班",
            "headmasterId": "1500000200060858961",
            "score": 0,
            "startTime": "2022-04-26T10:49:56.000+00:00",
            "reportDuration": null,
            "userName": "丽丽李",
            "account": null,
            "duration": 0,
            "warnFlag": 0,
            "cancelWarnUser": null,
            "cancelWarnTime": null,
            "sex": 1,
            "headmasterName": "心育测试老师1",
            "schoolId": "1500000200060858208",
            "schoolName": "智慧心育测试校3",
            "businessId": "1480386676658816",
            "userAge": 5,
            "guageName": null,
            "endTime": "2022-04-26 18:49:56",
            "evaluateType": 2,
            "deleteFlag": null,
            "effectiveFlag": 1,
            "createUser": null,
            "createTime": null,
            "modifyUser": null,
            "modifyTime": null,
            "doneRate": null,
            "code": null,
            "name": null,
            "totalNo": null
          },
          {
            "id": "117273",
            "gaugeId": "138258aa86b24ac3b782bf916ede30ef",
            "taskId": "19270df3afb44f1092f418189d6e0311",
            "userId": "1500000200060999369",
            "uncompletedNo": null,
            "completedNo": null,
            "aliasNo": null,
            "completeFlag": 1,
            "gradeId": "02",
            "gradeName": "二年级",
            "classId": "1500000200060999367",
            "className": "二年级1班",
            "headmasterId": null,
            "score": 0,
            "startTime": "2022-03-30T01:52:28.000+00:00",
            "reportDuration": null,
            "userName": "二年级1班学生1",
            "account": null,
            "duration": 3232,
            "warnFlag": 0,
            "cancelWarnUser": null,
            "cancelWarnTime": null,
            "sex": null,
            "headmasterName": null,
            "schoolId": "1500000200060858208",
            "schoolName": "智慧心育测试校3",
            "businessId": "8e033ab5d25c4b2782029c56bc208b11",
            "userAge": 0,
            "guageName": null,
            "endTime": "2022-03-30 09:52:33",
            "evaluateType": 2,
            "deleteFlag": null,
            "effectiveFlag": 1,
            "createUser": null,
            "createTime": null,
            "modifyUser": null,
            "modifyTime": null,
            "doneRate": null,
            "code": null,
            "name": null,
            "totalNo": null
          },
          {
            "id": "308",
            "gaugeId": "8619f746377d460a8d145e455e99ac6b",
            "taskId": "a228df7eb2e54de7b54fbe6c209f8597",
            "userId": "1500000200061057850",
            "uncompletedNo": null,
            "completedNo": null,
            "aliasNo": null,
            "completeFlag": 1,
            "gradeId": "02",
            "gradeName": "二年级",
            "classId": "1500000200060999367",
            "className": "1班改",
            "headmasterId": "1500000200061495832",
            "score": 0,
            "startTime": "2022-01-16T04:23:08.000+00:00",
            "reportDuration": null,
            "userName": "二年级的可可",
            "account": null,
            "duration": 3505,
            "warnFlag": 1,
            "cancelWarnUser": null,
            "cancelWarnTime": null,
            "sex": null,
            "headmasterName": "新增老师改",
            "schoolId": "1500000200060858208",
            "schoolName": "智慧心育测试校3",
            "businessId": "805ebbf358f34b51a0acbfda2feb78e2",
            "userAge": 0,
            "guageName": null,
            "endTime": "2022-01-16 12:23:12",
            "evaluateType": 2,
            "deleteFlag": null,
            "effectiveFlag": 1,
            "createUser": null,
            "createTime": null,
            "modifyUser": null,
            "modifyTime": null,
            "doneRate": null,
            "code": null,
            "name": null,
            "totalNo": null
          },
          {
            "id": "727",
            "gaugeId": "102a49d062604bfdab415eeae5c6978d",
            "taskId": "243720430d34454098c05d412e4885df",
            "userId": "1500000200060934067",
            "uncompletedNo": null,
            "completedNo": null,
            "aliasNo": null,
            "completeFlag": 1,
            "gradeId": "06",
            "gradeName": "六年级",
            "classId": "1500000200060932480",
            "className": "1班",
            "headmasterId": null,
            "score": 0,
            "startTime": "2022-02-11T08:01:15.000+00:00",
            "reportDuration": null,
            "userName": "六年级1班学生1",
            "account": null,
            "duration": 59233,
            "warnFlag": 2,
            "cancelWarnUser": null,
            "cancelWarnTime": null,
            "sex": null,
            "headmasterName": null,
            "schoolId": "1500000200060858208",
            "schoolName": "智慧心育测试校3",
            "businessId": "d655b1ab34b14e57b9212ef4fbcef92c",
            "userAge": 0,
            "guageName": null,
            "endTime": "2022-02-11 16:02:19",
            "evaluateType": 2,
            "deleteFlag": null,
            "effectiveFlag": 1,
            "createUser": null,
            "createTime": null,
            "modifyUser": null,
            "modifyTime": null,
            "doneRate": null,
            "code": null,
            "name": null,
            "totalNo": null
          },
          {
            "id": "153332",
            "gaugeId": "e15388e7f0f8454cb74a544050277796",
            "taskId": "1474233655104128",
            "userId": "1500000200061461560",
            "uncompletedNo": null,
            "completedNo": null,
            "aliasNo": null,
            "completeFlag": 1,
            "gradeId": "06",
            "gradeName": "六年级",
            "classId": "1500000200060932480",
            "className": "1班",
            "headmasterId": null,
            "score": 0,
            "startTime": "2022-04-25T08:47:04.000+00:00",
            "reportDuration": null,
            "userName": "六年级1班学生2被删",
            "account": null,
            "duration": 0,
            "warnFlag": 1,
            "cancelWarnUser": null,
            "cancelWarnTime": null,
            "sex": null,
            "headmasterName": null,
            "schoolId": "1500000200060858208",
            "schoolName": "智慧心育测试校3",
            "businessId": "f0f65abf2c0041289e488a7cc45afc6b",
            "userAge": 0,
            "guageName": null,
            "endTime": "2022-04-25 16:47:05",
            "evaluateType": 2,
            "deleteFlag": null,
            "effectiveFlag": 1,
            "createUser": null,
            "createTime": null,
            "modifyUser": null,
            "modifyTime": null,
            "doneRate": null,
            "code": null,
            "name": null,
            "totalNo": null
          },
          {
            "id": "154048",
            "gaugeId": "1409ad92c643464da3c1a3b294cebac0",
            "taskId": "1603180190258880",
            "userId": "1500000200060858256",
            "uncompletedNo": null,
            "completedNo": null,
            "aliasNo": null,
            "completeFlag": 1,
            "gradeId": "08",
            "gradeName": "八年级",
            "classId": "1500000200060858945",
            "className": "2班",
            "headmasterId": null,
            "score": 0,
            "startTime": "2022-05-18T03:24:58.000+00:00",
            "reportDuration": null,
            "userName": "刘亦菲",
            "account": null,
            "duration": 105283,
            "warnFlag": 1,
            "cancelWarnUser": null,
            "cancelWarnTime": null,
            "sex": null,
            "headmasterName": null,
            "schoolId": "1500000200060858208",
            "schoolName": "智慧心育测试校3",
            "businessId": "1603207815124672",
            "userAge": 0,
            "guageName": null,
            "endTime": "2022-05-18 11:24:58",
            "evaluateType": 2,
            "deleteFlag": null,
            "effectiveFlag": 1,
            "createUser": null,
            "createTime": null,
            "modifyUser": null,
            "modifyTime": null,
            "doneRate": null,
            "code": null,
            "name": null,
            "totalNo": null
          },
          {
            "id": "154105",
            "gaugeId": "e15388e7f0f8454cb74a544050277796",
            "taskId": "1616565527908992",
            "userId": "1500000200060858258",
            "uncompletedNo": null,
            "completedNo": null,
            "aliasNo": null,
            "completeFlag": 1,
            "gradeId": "11",
            "gradeName": "高二",
            "classId": "1500000200060858948",
            "className": "1班改ER班",
            "headmasterId": null,
            "score": 0,
            "startTime": "2022-05-20T12:03:00.000+00:00",
            "reportDuration": null,
            "userName": "圆圆",
            "account": null,
            "duration": 4724,
            "warnFlag": 2,
            "cancelWarnUser": null,
            "cancelWarnTime": null,
            "sex": null,
            "headmasterName": null,
            "schoolId": "1500000200060858208",
            "schoolName": "智慧心育测试校3",
            "businessId": "1616569426776704",
            "userAge": 0,
            "guageName": null,
            "endTime": "2022-05-20 20:03:00",
            "evaluateType": 2,
            "deleteFlag": null,
            "effectiveFlag": 1,
            "createUser": null,
            "createTime": null,
            "modifyUser": null,
            "modifyTime": null,
            "doneRate": null,
            "code": null,
            "name": null,
            "totalNo": null
          },
          {
            "id": "107295",
            "gaugeId": "e352e594a04e45daa5a48f046b1a34fd",
            "taskId": "e8f20887cace4e4b84fa02497e96d722",
            "userId": "1500000200061359292",
            "uncompletedNo": null,
            "completedNo": null,
            "aliasNo": null,
            "completeFlag": 1,
            "gradeId": "10",
            "gradeName": "高一",
            "classId": "1500000200060858946",
            "className": "1班改222",
            "headmasterId": "1500000200061495365",
            "score": 0,
            "startTime": "2022-03-18T07:18:39.000+00:00",
            "reportDuration": null,
            "userName": "姜豆学生",
            "account": null,
            "duration": 5000,
            "warnFlag": 1,
            "cancelWarnUser": null,
            "cancelWarnTime": null,
            "sex": null,
            "headmasterName": "新增心理二号老师",
            "schoolId": "1500000200060858208",
            "schoolName": "智慧心育测试校3",
            "businessId": "d534761ae3c64c3f83b2764ba5be5171",
            "userAge": 0,
            "guageName": null,
            "endTime": "2022-03-18 15:18:39",
            "evaluateType": 2,
            "deleteFlag": null,
            "effectiveFlag": 0,
            "createUser": null,
            "createTime": null,
            "modifyUser": null,
            "modifyTime": null,
            "doneRate": null,
            "code": null,
            "name": null,
            "totalNo": null
          },
          {
            "id": "153987",
            "gaugeId": "7f2441b483f745a09a039723c589bcf1",
            "taskId": "1592577790269120",
            "userId": "1500000200060858958",
            "uncompletedNo": null,
            "completedNo": null,
            "aliasNo": null,
            "completeFlag": 1,
            "gradeId": "10",
            "gradeName": "高一",
            "classId": "1500000200060858946",
            "className": "1班改222",
            "headmasterId": "1500000200061495365",
            "score": 0,
            "startTime": "2022-05-16T06:26:27.000+00:00",
            "reportDuration": null,
            "userName": "宵夜",
            "account": null,
            "duration": 45063,
            "warnFlag": 0,
            "cancelWarnUser": null,
            "cancelWarnTime": null,
            "sex": 0,
            "headmasterName": "新增心理二号老师",
            "schoolId": "1500000200060858208",
            "schoolName": "智慧心育测试校3",
            "businessId": "1592596821512832",
            "userAge": 0,
            "guageName": null,
            "endTime": "2022-05-16 14:26:27",
            "evaluateType": 2,
            "deleteFlag": null,
            "effectiveFlag": 1,
            "createUser": null,
            "createTime": null,
            "modifyUser": null,
            "modifyTime": null,
            "doneRate": null,
            "code": null,
            "name": null,
            "totalNo": null
          },
          {
            "id": "153358",
            "gaugeId": "e15388e7f0f8454cb74a544050277796",
            "taskId": "1474958692472512",
            "userId": "1500000200060931038",
            "uncompletedNo": null,
            "completedNo": null,
            "aliasNo": null,
            "completeFlag": 1,
            "gradeId": "07",
            "gradeName": "七年级",
            "classId": "1500000200060858246",
            "className": "1班",
            "headmasterId": "1500000200060858961",
            "score": 0,
            "startTime": "2022-04-25T11:52:32.000+00:00",
            "reportDuration": null,
            "userName": "小小1",
            "account": null,
            "duration": 0,
            "warnFlag": 1,
            "cancelWarnUser": null,
            "cancelWarnTime": null,
            "sex": null,
            "headmasterName": "心育测试老师1",
            "schoolId": "1500000200060858208",
            "schoolName": "智慧心育测试校3",
            "businessId": "104591015bc34eb2aec2a3028178bb8e",
            "userAge": 0,
            "guageName": null,
            "endTime": "2022-04-25 19:52:32",
            "evaluateType": 2,
            "deleteFlag": null,
            "effectiveFlag": 1,
            "createUser": null,
            "createTime": null,
            "modifyUser": null,
            "modifyTime": null,
            "doneRate": null,
            "code": null,
            "name": null,
            "totalNo": null
          },
          {
            "id": "560",
            "gaugeId": "5ed2f2fbe18e4bef8c252d93f3d52989",
            "taskId": "89ef54c005b3483d8fd1a73a8e877e08",
            "userId": "1500000200060931049",
            "uncompletedNo": null,
            "completedNo": null,
            "aliasNo": null,
            "completeFlag": 1,
            "gradeId": "07",
            "gradeName": "七年级",
            "classId": "1500000200060858246",
            "className": "1班",
            "headmasterId": "1500000200060858961",
            "score": 0,
            "startTime": "2022-01-25T05:52:41.000+00:00",
            "reportDuration": null,
            "userName": "小小11",
            "account": null,
            "duration": 3836,
            "warnFlag": 2,
            "cancelWarnUser": null,
            "cancelWarnTime": null,
            "sex": null,
            "headmasterName": "心育测试老师1",
            "schoolId": "1500000200060858208",
            "schoolName": "智慧心育测试校3",
            "businessId": "680a44a44e3444d09d46c99c37e6c806",
            "userAge": 0,
            "guageName": null,
            "endTime": "2022-01-25 13:52:46",
            "evaluateType": 2,
            "deleteFlag": null,
            "effectiveFlag": 0,
            "createUser": null,
            "createTime": null,
            "modifyUser": null,
            "modifyTime": null,
            "doneRate": null,
            "code": null,
            "name": null,
            "totalNo": null
          },
          {
            "id": "559",
            "gaugeId": "5ed2f2fbe18e4bef8c252d93f3d52989",
            "taskId": "89ef54c005b3483d8fd1a73a8e877e08",
            "userId": "1500000200060931050",
            "uncompletedNo": null,
            "completedNo": null,
            "aliasNo": null,
            "completeFlag": 1,
            "gradeId": "07",
            "gradeName": "七年级",
            "classId": "1500000200060858246",
            "className": "1班",
            "headmasterId": "1500000200060858961",
            "score": 0,
            "startTime": "2022-01-25T05:50:24.000+00:00",
            "reportDuration": null,
            "userName": "小小12",
            "account": null,
            "duration": 7599,
            "warnFlag": 2,
            "cancelWarnUser": null,
            "cancelWarnTime": null,
            "sex": null,
            "headmasterName": "心育测试老师1",
            "schoolId": "1500000200060858208",
            "schoolName": "智慧心育测试校3",
            "businessId": "3a49483602e14e40bab9b578b5dfbc12",
            "userAge": 0,
            "guageName": null,
            "endTime": "2022-01-25 13:50:34",
            "evaluateType": 2,
            "deleteFlag": null,
            "effectiveFlag": 0,
            "createUser": null,
            "createTime": null,
            "modifyUser": null,
            "modifyTime": null,
            "doneRate": null,
            "code": null,
            "name": null,
            "totalNo": null
          },
          {
            "id": "557",
            "gaugeId": "5ed2f2fbe18e4bef8c252d93f3d52989",
            "taskId": "89ef54c005b3483d8fd1a73a8e877e08",
            "userId": "1500000200060931052",
            "uncompletedNo": null,
            "completedNo": null,
            "aliasNo": null,
            "completeFlag": 1,
            "gradeId": "07",
            "gradeName": "七年级",
            "classId": "1500000200060858246",
            "className": "1班",
            "headmasterId": "1500000200060858961",
            "score": 0,
            "startTime": "2022-01-25T05:47:59.000+00:00",
            "reportDuration": null,
            "userName": "小小14",
            "account": null,
            "duration": 5180,
            "warnFlag": 2,
            "cancelWarnUser": null,
            "cancelWarnTime": null,
            "sex": null,
            "headmasterName": "心育测试老师1",
            "schoolId": "1500000200060858208",
            "schoolName": "智慧心育测试校3",
            "businessId": "5f1bbc7e622b47fcadc71d03d5b8ecad",
            "userAge": 0,
            "guageName": null,
            "endTime": "2022-01-25 13:48:05",
            "evaluateType": 2,
            "deleteFlag": null,
            "effectiveFlag": 0,
            "createUser": null,
            "createTime": null,
            "modifyUser": null,
            "modifyTime": null,
            "doneRate": null,
            "code": null,
            "name": null,
            "totalNo": null
          },
          {
            "id": "556",
            "gaugeId": "5ed2f2fbe18e4bef8c252d93f3d52989",
            "taskId": "89ef54c005b3483d8fd1a73a8e877e08",
            "userId": "1500000200060931053",
            "uncompletedNo": null,
            "completedNo": null,
            "aliasNo": null,
            "completeFlag": 1,
            "gradeId": "07",
            "gradeName": "七年级",
            "classId": "1500000200060858246",
            "className": "1班",
            "headmasterId": "1500000200060858961",
            "score": 0,
            "startTime": "2022-01-25T05:47:07.000+00:00",
            "reportDuration": null,
            "userName": "小小15",
            "account": null,
            "duration": 5102,
            "warnFlag": 2,
            "cancelWarnUser": null,
            "cancelWarnTime": null,
            "sex": null,
            "headmasterName": "心育测试老师1",
            "schoolId": "1500000200060858208",
            "schoolName": "智慧心育测试校3",
            "businessId": "201b75403d85478e942fa5bb7d2e6c1f",
            "userAge": 0,
            "guageName": null,
            "endTime": "2022-01-25 13:47:13",
            "evaluateType": 2,
            "deleteFlag": null,
            "effectiveFlag": 0,
            "createUser": null,
            "createTime": null,
            "modifyUser": null,
            "modifyTime": null,
            "doneRate": null,
            "code": null,
            "name": null,
            "totalNo": null
          }

        ],
        "maxOptionNum": null
      };
      const { dataList, pageNo, totalCount } = res;
      this.allData = dataList;
      this.tableData = this.allData.slice(0, 10);
      this.page.pageNum = pageNo;
      this.total = totalCount;
    },
    // 查看学生报告详情
    viewDetail (row) {
      this.$router.push({
        name: "/measure/personalReport",
        query: {
          businessId: row.businessId,
          studentId: row.userId,
          endTime: row.endTime,
        },
      });
    },
    // 处理页数变化
    handleCurrent (num) {
      this.page.pageNum = num;
      if (num === 1) {
        this.tableData = this.allData.slice(0, 10);
      } else {
        this.tableData = this.allData.slice(10 * (this.page.pageNum - 1), 10 * this.page.pageNum);
      }
      console.log(this.tableData);
    },
    // 选择年级
    selectGrade (val) {
      this.queryForm.classId = "all";
      this.classOptions = [];
      if (val === 'all') {
        this.classOptions = [
          { name: '全部', code: 'all' },
        ];
      } else {
        let classData = this.gradeOptions.filter(item => {
          if (item.code === val) {
            return item;
          }
        })[0].children;
        classData.unshift({ name: '全部', code: 'all' });
        this.classOptions = classData;
      }
      console.log(val);

    },
  },
};
</script>

<style scoped lang="scss">
// @import '';
::v-deep .el-breadcrumb__inner.is-link {
  color: #8c8c8c;
  font-weight: normal;
  font-size: 12px;
  &:hover {
    color: #368fff;
    font-weight: 400 !important;
  }
}
::v-deep .el-breadcrumb__inner {
  font-size: 12px;
  color: #262626;
}
.el-breadcrumb__item:last-child ::v-deep .el-breadcrumb__inner {
  font-size: 12px;
  color: #262626;
}
::v-deep .el-breadcrumb__inner a {
  color: #262626;
  font-weight: normal;
}

::v-deep .el-breadcrumb__separator {
  font-size: 12px;
}
.el-breadcrumb {
  margin-bottom: 16px;
}
.content-box {
  padding: 24px;
  background: #fff;
  min-height: calc(100vh - 55px);
  .queryForm {
    position: relative;
    .keyWord {
      position: absolute;
      right: 0;
    }
  }
  .tables {
    margin-bottom: 20px;
  }
  .opeatBtn {
    padding: 0;
  }
}
</style>
